import React from 'react';
import { Switch, Route } from 'react-router-dom';
import LinkPrev from '../player/pages/quizPlayer/LinkPrev.jsx';

/**
 *
 * @type {React.NamedExoticComponent<object>}
 */
const Screen = React.memo(() => {
    return (
        <Switch>
            <Route
                path='/screen/player/quiz/:quizID'
                component={LinkPrev}
            />
        </Switch>
    );
});

export default Screen;